import React, { useRef, useState, useEffect, useCallback } from 'react'

const Timer = (props) => {
  const timeoutId = useRef(null)
  const [timer, setTimer] = useState(localStorage.getItem(props.storageItem) - Date.now())
  const [showTimer, setShowTimer] = useState(true)

  const countTimer = useCallback(() => {
    if (!localStorage.getItem(props.storageItem) || timer <= 0) {
      localStorage.removeItem(props.storageItem)
      setShowTimer(false)
      if (props.callback) props.callback(true)
    } else {
      setTimer(timer - 1000)
    }
  }, [timer])

  useEffect(() => {
    timeoutId.current = window.setTimeout(countTimer, 1000)
    // cleanup function
    return () => window.clearTimeout(timeoutId.current)
  }, [timer, countTimer])

  const msToMinutes = (milli) => {
    var seconds = Math.floor((milli / 1000) % 60)
    var minutes = Math.floor((milli / (60 * 1000)) % 60)

    if (seconds < 10) {
      seconds = '0' + seconds
    }
    return minutes + ':' + seconds
  }

  return (
    <>
      {showTimer ? (
        <div className='d-flex flex-row mb-2 mt-2'>
          {props.message}
          {msToMinutes(timer)}
        </div>
      ) : null}
    </>
  )
}

export default Timer
